var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgZoomIn = function SvgZoomIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.672 16.89c.41.438.41 1.122 0 1.56a1.14 1.14 0 0 1-1.559 0l-3.254-3.282c-1.12.738-2.488 1.121-3.964.902-2.516-.328-4.54-2.379-4.868-4.867a5.7 5.7 0 0 1 6.399-6.398c2.488.328 4.539 2.351 4.894 4.867a5.678 5.678 0 0 1-.93 3.937l3.282 3.282Zm-5.797-5.796a.648.648 0 0 0 .656-.656c0-.356-.3-.657-.683-.657h-1.532V8.25c0-.355-.328-.656-.656-.656-.355 0-.629.3-.629.656v1.531H8.473c-.356 0-.63.301-.63.656 0 .383.274.657.63.657h1.558v1.531c0 .383.274.656.656.656a.642.642 0 0 0 .63-.656v-1.531h1.558Z"
  })));
};

export default SvgZoomIn;